module.exports = __webpack_public_path__ + "img/funnel.76c3a2d7.svg";